module.exports = __webpack_public_path__ + "static/media/todoist_icon.cf5d5875.png";